import { baseQuery } from '../baseQuery';

type PostTechnicianAwayStatusPayload = {
  technicianId: number;
  start_date: string;
  end_date: string;
};

export const postTechnicianAwayStatus = async (payload: PostTechnicianAwayStatusPayload) => {
  const { technicianId, ...rest } = payload;
  const { data } = await baseQuery(`technicians/${technicianId}/away-statuses`, {
    type: 'POST',
    body: {
      ...rest,
    },
  });

  return data;
};
